import React from "react";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

import CollapseCard from "components/Collapse";
import TwoColumnContainer from "components/Container/TwoColumnContainer";

const NetworkPanel = ({ networkData, infoData }) => {
  const { deviceType, managedProtocol } = infoData;
  const isProxy = deviceType === "proxy";
  const isAp = deviceType === "ap" && managedProtocol === "nc";
  const isSwitch = deviceType === "switch";

  const StyledTypography = styled(Typography)(({ theme }) => ({
    fontSize: theme.typography.customFontSize[2],
    color: theme.palette.primary.black,
    fontWeight: theme.typography.customFontWeight[1],
  }));

  const fields = [
    {
      key: "publicIp",
      label: "Public Mgmt. IP",
      display: isAp || isProxy || isSwitch,
    },
    { key: "localIp", label: "Local Mgmt. IP", display: true },
    { key: "subnetMask", label: "Subnet Mask", display: !isAp },
    { key: "defaultGateway", label: "Gateway", display: !isAp },
    { key: "primaryDns", label: "Primary DNS Server", display: !isAp },
    { key: "sencondaryDns", label: "Secondary DNS Server", display: !isAp },
    // proxy 時隱藏
    { key: "mgmtVlan", label: "Management VLAN", display: !isProxy },
    // proxy 時隱藏
    {
      key: "uplinkDeviceName",
      label: "Uplink Device",
      display: !isProxy,
    },
  ];

  return (
    <CollapseCard title="Network">
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        {fields.map(({ key, label, display }) => {
          if (!display) return null;

          return (
            <TwoColumnContainer key={key} label={label}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  gap: 2,
                  alignItems: "center",
                }}
              >
                <StyledTypography>
                  {key === "uplinkDeviceName"
                    ? networkData.uplinkDeviceName ||
                      networkData.uplinkDeviceMac ||
                      "-"
                    : networkData[key] || "-"}
                </StyledTypography>
              </Box>
            </TwoColumnContainer>
          );
        })}
      </Box>
    </CollapseCard>
  );
};

export default NetworkPanel;
